'use client';
import { useEffect } from 'react';

export function RedirectEffect() {
  useEffect(() => {
    const pathname = window.location.pathname;

    redirectToLoginWithRedirect(pathname);
  }, []);

  return null;
}

export function redirectToLoginWithRedirect(path: string) {
  location.href = `/user/sign-in?redirect=${encodeURIComponent(path)}`;
}
